import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Button from '@/components/Button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger
} from '@/components/DropdownMenu';
import More from '@/icons/more.svg';
import {
	setIsModalUpgradePlanOpen,
	setModalUpgradePlanScope
} from '@/store/profile';

import { useOptions } from './hooks';
import { DialogItem } from './modals';

export function DropdownMenuCell({ row }) {
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const dispatch = useDispatch();
	const isModalUpgradePlanOpen = useSelector(
		state => state.profile.isModalUpgradePlanOpen
	);
	const { options, openOption, setOpenOption, shouldOpenOption } =
		useOptions();

	const focusRef = useRef(null);

	useEffect(() => {
		if (!shouldOpenOption(openOption)) {
			dispatch(setIsModalUpgradePlanOpen(true));
			dispatch(setModalUpgradePlanScope(openOption));
		}
	}, [openOption]);

	useEffect(() => {
		if (!isModalUpgradePlanOpen) {
			setOpenOption(false);
		}
	}, [isModalUpgradePlanOpen]);

	return (
		<div className="flex w-full justify-end">
			<DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
				<DropdownMenuTrigger asChild>
					<Button variant="ghost" className="h-8 w-8 p-0">
						<span className="sr-only">Open menu</span>
						<More className="h-5 w-5" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent
					align="center"
					side="left"
					onCloseAutoFocus={event => {
						if (focusRef.current) {
							focusRef.current.focus();
							focusRef.current = null;
							event.preventDefault();
						}
					}}
				>
					<DialogItem
						row={row}
						closeMenu={() => setDropdownOpen(false)}
						options={options}
						setOpenOption={setOpenOption}
					/>
				</DropdownMenuContent>
			</DropdownMenu>
			{options.map(({ Component, name }) => (
				<Component
					key={name}
					open={shouldOpenOption(name)}
					onOpenChange={setOpenOption}
					selectedTransactions={[row.original]}
				/>
			))}
		</div>
	);
}
